import React, { Component } from "react";
import {
    Link,
    Redirect,
    withRouter,
    RouteComponentProps
} from "react-router-dom";
import { connect } from "react-redux";

import { homeStoreSelectors } from "../../store/store";
import { HomeActionCreators } from "../../actions/actionCreators";
import { ActionCreator } from "../../../../actions/actions";
import { SubAppConfig } from "../../../../reducers/subAppsConfig.reducer";

import { checkForRouteAvailability } from "../../../../utils/Authorization/authorization";

export interface HomeProps extends RouteComponentProps {
    activeSubApps: SubAppConfig[];
    selectedSubApp: SubAppConfig;
    selectSubApp: ActionCreator;
}

export interface TopbarState {
    selectedSubApp: SubAppConfig;
    showNotifications: boolean;
}

class HomePageIndex extends Component<HomeProps> {
    private initialRedirect: boolean = false;

    renderRedirects() {
        if (this.initialRedirect) return;

        this.initialRedirect = true;

        const redirectToDefault =
            this.props.location.pathname === "/" ||
            this.props.location.pathname === "/login" ||
            (this.props.selectedSubApp &&
                this.props.selectedSubApp.route &&
                !this.props.selectedSubApp.route.find(route =>
                    checkForRouteAvailability(route)
                ));

        const redirectToSelected =
            this.props.selectedSubApp &&
            this.props.selectedSubApp.pathname &&
            !this.props.location.pathname.startsWith(
                this.props.selectedSubApp.pathname
            );

        const redirectToSubApp =
            !this.props.selectedSubApp &&
            !redirectToDefault &&
            !redirectToSelected &&
            !!this.props.activeSubApps.find(subApp =>
                this.props.location.pathname.startsWith(subApp.pathname)
            );

        if (redirectToDefault) {
            const defaultApp =
                this.props.activeSubApps.find(subApp => subApp.default) ||
                this.props.activeSubApps[0];

            if (!defaultApp) {
                return null;
            }

            this.selectSubApp(defaultApp);

            return <Redirect to={defaultApp.pathname} />;
        } else if (redirectToSelected) {
            return <Redirect to={this.props.selectedSubApp.pathname} />;
        } else if (redirectToSubApp) {
            const app = this.props.activeSubApps.find(subApp =>
                this.props.location.pathname.startsWith(subApp.pathname)
            );

            this.selectSubApp(app);

            return <Redirect to={this.props.location.pathname} />;
        }
    }

    selectSubApp(subApp) {
        this.props.selectSubApp(subApp);
    }

    render() {
        return <React.Fragment>{this.renderRedirects()}</React.Fragment>;
    }
}

const mapStateToProps = state => ({
    activeSubApps: homeStoreSelectors.activeSubApps(state),
    selectedSubApp: homeStoreSelectors.selectedSubApp(state)
});

const mapDispatchToProps = {
    selectSubApp: HomeActionCreators.selectSubApp
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(HomePageIndex));
